import * as React from 'react';
import {Linking, Text, TouchableOpacity, View} from 'react-native';
import {useSelector} from 'react-redux';
import {useNavigation} from '@react-navigation/native';
import {images} from '../../../../assets/icons';
import {contentSelector} from '../../../../redux/selectors/resources';
import {canReissueCardSelector} from '../../../../redux/selectors/cardReissue';
import {useStyles} from '../../../hooks/styles';
import {formatPhone, formatPhoneToCallable} from '../../../pipes';
import {useTheme} from '../../../theme';
import {Button} from '../../../components/button';
import {useCallback, useMemo} from 'react';
import {OrDelimiter} from '../../orDelimiter';
import {DeviceSize} from '../../../theme/helpers';
import {Screens} from '../../../routing';

export const CardInfoCardBlocked: React.FC = () => {
  const content = useSelector(contentSelector());
  const canReissueCard = useSelector(canReissueCardSelector());
  const navigation = useNavigation();
  const theme = useTheme();
  const styles = useStyles(({mediaOnly}) => ({
    container: {
      width: '100%',
      alignItems: 'stretch',
      paddingVertical: 10,
      paddingHorizontal: 20,
    },
    message: {
      marginBottom: 24,
      ...theme.fonts.body,
      color: theme.color.textColor,
      ...mediaOnly(DeviceSize.mobile, {
        textAlign: 'center',
      }),
    },
    phoneLink: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf: 'center',
    },
    phoneNumber: {
      ...theme.fonts.action,
      color: theme.color.primaryColor,
      marginLeft: 10,
      flexShrink: 0,
    },
    button: {
      width: '100%',
    },
  }));

  const formattedPhone = useMemo(
    () => formatPhone(content.esksoContacts.supportPhone),
    [content.esksoContacts.supportPhone],
  );

  const handleClickCall = useCallback(() => {
    const phone = formatPhoneToCallable(content.esksoContacts.supportPhone);
    Linking.openURL(`tel:${phone}`);
  }, [content.esksoContacts.supportPhone]);

  const handleReissueCard = useCallback(() => {
    if (!canReissueCard) {
      return;
    }
    navigation.navigate(Screens.CardReissue as never);
  }, [canReissueCard, navigation]);

  return (
    <View style={styles.container} testID='blocked-card'>
      <Text style={styles.message} testID='blocked-card-message'>
        {content.cardBlocking.unblockMessage}
      </Text>
      {canReissueCard ? (
        <>
          <Button
            id='profile-reissue-card'
            type='secondary'
            text='Перевыпустить карту'
            block
            style={styles.button}
            onPress={handleReissueCard}
          />
          <OrDelimiter marginTop={16} marginBottom={16} />
        </>
      ) : null}
      <TouchableOpacity testID='card-info-phone' style={styles.phoneLink} onPress={handleClickCall}>
        <images.Phone width={18} height={18} color={theme.color.primaryColor} />
        <Text style={styles.phoneNumber}>{formattedPhone}</Text>
      </TouchableOpacity>
    </View>
  );
};
